const showcase = document.querySelector('.js-showcase');

if (showcase) {
    const products = [...showcase.querySelectorAll('.js-showcase-product')];

    products.forEach(product => {
        product.addEventListener('click', (e) => {
            e.stopPropagation();
            const popup = product.nextElementSibling;
            popup.classList.toggle('hidden');
        });
    });

    showcase.addEventListener('click', () => {
        const popups = showcase.querySelectorAll('.js-showcase-popup');
        popups.forEach(popup => {
            popup.classList.add('hidden');
        });
    });
}
